import React, { Component } from 'react'
import { Button, ButtonGroup, Intent, Spinner, Popover, Menu, MenuItem, Position } from '@blueprintjs/core';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import Toast from 'helpers/toaster';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

var url_string = window.location.href;
var url = new URL(url_string);
var is_import = url.searchParams.get("import");

@inject('store', 'viewStore', 'clientStore') @observer
class Client extends Component {

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.clientSearch.page = 1;
    viewStore.clients();
  }

  @action
  onSearchTermChange(e) {
    let {
      props: {
        viewStore: {
          clientSearch
        }
      }
    } = this;
    this.props.viewStore.clientSearch = {
      ...clientSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  handleUploadingCustomerCSV = (event) => {
    var file = event.target.files[0];
    if (file.type == 'text/csv') {
      this.props.clientStore.showUploadAttachmentLoader = true;
      this.props.clientStore.uploadCsv(file)
        .then(this.onSuccessfullUploadAttachment.bind(this))
        .catch(this.onFailUploadAttachment.bind(this))
    } else {
      Toast.show({ icon: 'warning-sign', message: 'File type not matched, only .csv allowed!', intent: Intent.DANGER })
    }
  };

  onSuccessfullUploadAttachment(response) {
    let {
      clientStore: {
        importClients: {
          objects
        }
      }
    } = this.props;
    this.props.clientStore.showUploadAttachmentLoader = false;
    Toast.show({ icon: 'thumbs-up', message: 'Client records imported successfully!', intent: Intent.SUCCESS })
    this.props.clientStore.loadClients();
  }

  onFailUploadAttachment(error) {
    this.props.clientStore.showUploadAttachmentLoader = false;
    if (error.response && error.response.data && error.response.data.error) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.error, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, failed to upload file!', intent: Intent.DANGER })
    }
  }
  download_bulk_excel() {
    this.props.clientStore.download_bulk_excel(this.props.viewStore.clientSearch)
  }
  render() {
    let {
      props: {
        store,
        viewStore: {
          clientSearch: { term },
          currentUser
        },
        clientStore: {
          showUploadAttachmentLoader
        }
      }
    } = this;

    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <>
            {
              is_import == 'true' &&
              <span className="btn btn-light btn-sm btn-file">
                Import Clients <input type="file" onChange={this.handleUploadingCustomerCSV.bind(this)} />
                {showUploadAttachmentLoader &&
                  <Spinner size={Spinner.SIZE_SMALL} />}
              </span>
            }
            {currentUser?.attributes?.role == 'admin' &&
              <Popover
                minimal={true}
                content={
                  <Menu>
                    <MenuItem text="Download Excel/CSV" onClick={this.download_bulk_excel.bind(this)} />
                  </Menu>
                }
                position={Position.BOTTOM_LEFT}
                usePortal={true}>
                <Button rightIcon='caret-down'>
                  Options
                </Button>
              </Popover>
            }
          </>
        }
      >
        <input
          type="text"
          className="bp3-input input-control search-filters-toolbar__field-wide"
          placeholder="Client Name, Number, Email or Address"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }
}

export default Client;
